import React from 'react';

import { blindMapIncorrectHit } from '../../../actions/contentItemActions';
import { HintButton } from '../../../components/shared/HintButton';
import { getMainProjectPanorama } from '../../../globalPanoramaAccessor';
import { useLocatingHiddenAreaInStudent } from '../../../hooks/useLocatingHiddenAreaInStudent';
import { useStudentDispatch } from '../../../hooks/useStudentDispatch';
import { addCompletedItem } from '../../../store/reducers/student/tracking/itemsTrackingActions';
import { BlindMapIntroduction } from './BlindMapIntroduction';
import { BlindMapQuestion } from '@ael/core-api';

export type BlindMapProps = {
  blindMapItem: BlindMapQuestion;
  shouldDisplayBlindMapIntroduction: boolean;
  displayBlindMapHintButton: boolean;
  onSubmit: (questionId: string, correctHit: boolean) => void;
};

export const BlindMap: React.FC<BlindMapProps> = ({
  blindMapItem,
  displayBlindMapHintButton,
  shouldDisplayBlindMapIntroduction,
  onSubmit,
}) => {
  const panorama = getMainProjectPanorama();
  const dispatch = useStudentDispatch();

  const confirmPosition = (correct: boolean) => {
    if (correct) {
      setTimeout(() => {
        onSubmit(blindMapItem.id, true);
        dispatch(addCompletedItem(blindMapItem.id));
      }, 750);
    } else {
      onSubmit(blindMapItem.id, false);
      dispatch(blindMapIncorrectHit());
    }
  };

  const { displayHint } = useLocatingHiddenAreaInStudent(
    panorama,
    blindMapItem.cameraPosition,
    [blindMapItem.position],
    confirmPosition
  );

  return (
    <>
      {displayBlindMapHintButton && <HintButton onClick={displayHint} />}
      {shouldDisplayBlindMapIntroduction && <BlindMapIntroduction key={blindMapItem.id} />}
    </>
  );
};
